<template>
  <b-form-group class="mb-2" label-class="pb-1">
    <template slot="label">
      <b class="mb-0 pb-0">Task created by: </b>
    </template>
    <vue-single-select
      :classes="{
        input: 'form-control mt-0',
        dropdown: 'dropdown p-0',
      }"
      v-model="userCreated"
      :options="users"
      :getOptionDescription="() => userName"
      class=""
    >
      <template slot="option" slot-scope="{ option }">
        <div class="" @click="setUserCreated()">
          <span>
            {{ option.firstName }} {{ option.lastName }} ({{ option.nickname }})</span
          >
        </div>
      </template>
    </vue-single-select>
  </b-form-group>
</template>

<script>
import { mapState } from "vuex";
import VueSingleSelect from "vue-single-select";
import { SET_TASKS_FILTERS } from "../actions";
export default {
  name: "UserCreatedFilter",
  components: {
    VueSingleSelect,
  },
  computed: {
    ...mapState({
      users: (state) => state.superAdminStore.tasks.users.data,
      filters: (state) => state.superAdminStore.tasks.tasks.filters,
    }),
    userName() {
      if (this.userCreated) {
        return `${this.userCreated.firstName} ${this.userCreated.lastName}`;
      }
      return "";
    },
  },
  watch: {
    userCreated() {
      this.setUserCreated();
    },
  },
  mounted() {
    this.getFilterFromStore();
  },
  data() {
    return {
      userCreated: null,
    };
  },
  methods: {
    setUserCreated() {
      this.$store.commit(SET_TASKS_FILTERS, {
        fields: {
          userId: this.userCreated?.id,
        },
      });
    },
    getFilterFromStore() {
      this.userCreated =
        this.users.find((user) => user.id === this.filters.userId) || null;
    },
  },
};
</script>

<style lang="sass" scoped>
.col-form-label
  padding-bottom: 0
</style>
